/**
 * Class description
 *
 * Created: 2018-01-29
 * @author jonas
 */
import {DungeonQuestBaseStateSprite} from "./DungeonQuestBaseStateSprite";
import {DungeonQuest} from "../../DungeonQuest";
import {Linear, TimelineLite, TweenLite} from "gsap"

export class DungeonQuestTransformStateTimelineSprite extends DungeonQuestBaseStateSprite {
    private _whiteOutSprite:PIXI.Sprite;

    constructor(textures:PIXI.Texture[], sourceFPS?:number) {
        super(textures, sourceFPS);
    }

    protected initGraphics() {
        this._whiteOutSprite = new PIXI.Sprite(DungeonQuest.colorEffectTextureCache.getWhiteTexture(this._textures[0]));
        this._whiteOutSprite.anchor.set(0.5, 0.5);
        this._whiteOutSprite.alpha = 0;
        this._whiteOutSprite.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this._whiteOutSprite);
    }

    public getAnimation(frames?:number[], onUpdateCallback?:() => void, onCompleteCallback?:() => void):TimelineLite {
        let tl = super.getAnimation(frames, onUpdateCallback, onCompleteCallback);
        tl.add(() => this.moveSymbolToTop());

        tl.add(new TweenLite(this._whiteOutSprite, 0.2, {alpha : 1}));
        tl.add(new TweenLite(this._whiteOutSprite, 0.4, {alpha : 0, ease : Linear.easeNone}), 0.8);
        //tl.add(new TweenLite(this._whiteOutSprite.scale,0.4,{x:1.5,y:1.5, ease:Linear.easeNone}),0.2);

        return tl;
    }


}